import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Canonicalize to www (apex energie-tarifberater.de -> www.energie-tarifberater.de)
if (typeof window !== "undefined" && window.location.hostname === "energie-tarifberater.de") {
  window.location.replace(
    "https://www.energie-tarifberater.de" + window.location.pathname + window.location.search + window.location.hash
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Crawlers receive the prerendered static HTML; browsers cleanly client-render
// (createRoot replaces the prerendered markup on first render -> no hydration
// mismatch with framer-motion/dynamic content, no duplicate content).
ReactDOM.createRoot(container).render(app);
